import { render, staticRenderFns } from "./AepSuppFields.vue?vue&type=template&id=18e1f2d5&lang=pug"
import script from "./AepSuppFields.vue?vue&type=script&lang=js"
export * from "./AepSuppFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports